$(function () {
    $(".ar-carousel-block.ar-carousel-block_horizontal .ar-carousel-block__slides-container").slick({
        centerMode: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    arrows: false,
                    variableWidth: false
                }
            }
        ]
    });

    $(".ar-carousel-block.ar-carousel-block_vertical .ar-carousel-block__slides-container").slick({
        arrows: false
    });

    $(".ar-carousel-block")
        .on("click", ".carousel-block-slide__next", function (e) {
            e.preventDefault();
            $(this).closest(".ar-carousel-block__slides-container").slick("slickNext");
        })
        .on("click", ".carousel-block-slide__previous", function (e) {
            e.preventDefault();
            $(this).closest(".ar-carousel-block__slides-container").slick("slickPrev");
        });
});